import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Animated from '../AnimatedLetters/Animated';
import LogoTitle from '../../assets/images/Logo-a.png'
import './Home.scss'
import LogoS from '../../assets/images/Logo-a.png'
import ProjectSection from '../Projects/ProjectSection';
import Skill from '../Skill/Skills';
import Experience from '../Experience/Experience';



const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    const nameArray = ['r', 'e', 'f', 'i', 'n']
    const jobArray = [
        'F',
        'u',
        'l',
        'l',
        '-',
        'S',
        't',
        'a',
        'c',
        'k',
        ' ',
        'D',
        'e',
        'v',
        'e',
        'l',
        'o',
        'p',
        'e',
        'r',
    ]

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 4000)
    }, [])


    return (

        <div className='container home-s'>
            <div className="i-right d-md-none">
                <div className="i-bg">
                    <img src={LogoS} alt="" className="i-img" />
                </div>
            </div>

            <div className="row flex-md-row gap-5">
                <div className="col d-flex align-items-lg-center">
                    <div className="home-page">
                        <div>
                            <h1>
                                <span className={letterClass}>H</span>
                                <span className={`${letterClass} _12`}>i,</span>
                                <br />
                                <span className={`${letterClass} _13`}>I</span>
                                <span className={`${letterClass} _14`}>'m</span>
                                <img className='h1-img'
                                    src={LogoTitle}
                                    alt="JavaScript Developer Name, Web Developer Name"
                                />
                                <Animated
                                    letterClass={letterClass}
                                    strArray={nameArray}
                                    idx={15}
                                />
                                <br />
                                <Animated
                                    letterClass={letterClass}
                                    strArray={jobArray}
                                    idx={22}
                                />
                            </h1>
                            <h2>Full Stack Developer | MERN Stack | Django | NoSQL/SQL</h2>

                            <div>
                                <div className="d-flex gap-3">
                                    <div>
                                        <Link to="/contact" className="flat-button">
                                            CONTACT ME
                                        </Link>
                                    </div>
                                    <div>
                                        <a className="resume-button disabled-button" onClick={(e) => e.preventDefault()} href="#">MY RESUME</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <svg
                            width="75"
                            height="75"
                            viewBox="0 0 75 75"
                            fill="none"
                            stroke="yellow"
                            className="i-scroll bounce-animation"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => window.scrollBy({ top: window.innerHeight, behavior: 'smooth' })}
                        >
                            <g id="scroll">
                                <path
                                    id="Vector"
                                    d="M40.5 15L34.5 9L28.5 15"
                                    stroke-width="3"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    id="Vector_2"
                                    d="M28.5 24L34.5 30L40.5 24"
                                    stroke-width="3"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <g id="Group">
                                    <path
                                        id="Vector_3"
                                        d="M9 37.5H60"
                                        stroke-width="3"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </g>
                                <path
                                    id="Vector_4"
                                    d="M34.5 27V9"
                                    stroke-width="2.9895"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <g id="Group_2">
                                    <path
                                        id="Vector_5"
                                        d="M9 27C9 12.918 20.418 1.5 34.5 1.5C48.5859 1.5 60 12.918 60 27C60 29.8906 60 45.1094 60 48C60 62.082 48.5859 73.5 34.5 73.5C20.418 73.5 9 62.082 9 48C9 45.1094 9 29.8906 9 27Z"
                                        stroke-width="3"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>

                </div>

                <div className="col d-none d-md-block">
                    <div className="i-right">
                        <div className="i-bg">
                            <img src={LogoS} alt="" className="i-img" />
                        </div>
                    </div>
                </div>

            </div>

            <Skill></Skill>

            <Experience></Experience>

            <ProjectSection></ProjectSection>

        </div>


    );
};

export default Home;